import i18n from 'i18next';
import { call, put, select, takeLatest } from 'redux-saga/effects';

import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';

import { getErrorMessageFromAPI } from '../../utilz';
import { setAppLoader } from '../common/CommonActions';
import { getShipmentDetailsInProgress, setShipmentData } from '../shipment/ShipmentActions';
import {
  editDetailsBtn,
  editGeneralBtn,
  getSearchVisibilityListError,
  getSearchVisibilityListSuccess,
  getShipmentNotesAndDetails,
  getShipmentNotesAndDetailsFail,
  getShipmentNotesAndDetailsSuccess,
  getShipperConsigneeDetailsFail,
  getShipperConsigneeDetailsSuccess,
  getTrackingStatusDetailsError,
  getTrackingStatusDetailsSuccess,
  getVisibilityExcelDataError,
  getVisibilityExcelDataSuccess,
  getVisibilityProductInfoFail,
  getVisibilityProductInfoSuccess,
  updateRefAndDockNoFail,
  updateRefAndDockNoSuccess,
  updateSearchVisibilityList,
  updateSearchVisibilityListSuccess,
  updateShipmentTrackingDetailsClear,
  updateShipmentTrackingDetailsFail,
  updateShipmentTrackingDetailsSuccess,
} from './VisibilityActions';
import {
  getProductInfoEffects,
  getShipmentNotesAndDetailsEffects,
  getShipperConsigneeDetailsEffects,
  getTrackingStatusDetailsEffects,
  getVisibilityExportExcelEffects,
  getVisibilitySearchListEffects,
  sendEmailEffects,
  updateRefAndDockNoEffects,
  updateShipmentDetailsEffects,
  updateShipmentNoteEffects,
  updateShipmentTrackingDetailsEffects,
} from './VisibilityEffects';
import VisibilityTypes from './VisibilityTypes';

function* getVisibilitySearchListAction() {
  const { visibilitySearchList } = yield select((state) => state.visibility);
  const {
    user: { data: userDetails },
  } = yield select((state) => state.auth);

  try {
    const { userType } = userDetails;

    const { data } = yield call(getVisibilitySearchListEffects, {
      ...visibilitySearchList.req,
      userType,
    });

    yield put(getSearchVisibilityListSuccess({ data }));
  } catch (e) {
    yield put(
      getSearchVisibilityListError({
        message: getErrorMessageFromAPI(e, `${i18n.t('translation:default.notification.failedTrackingDetails')}!`),
      }),
    );
  }
}

function* getTrackingStatusDetailsAction({ payload }) {
  try {
    const { data } = yield call(getTrackingStatusDetailsEffects, payload);
    yield put(
      getTrackingStatusDetailsSuccess({
        data,
      }),
    );
  } catch (e) {
    yield put(
      getTrackingStatusDetailsError({
        message: getErrorMessageFromAPI(e, `${i18n.t('translation:default.notification.failedTrackingDetails')}!`),
      }),
    );
  }
}

function* getVisibilityProductInfoAction({ payload }) {
  try {
    const { data } = yield call(getProductInfoEffects, payload);
    yield put(
      getVisibilityProductInfoSuccess({
        data,
      }),
    );
  } catch (e) {
    yield put(
      getVisibilityProductInfoFail({
        message: getErrorMessageFromAPI(e, `${i18n.t('translation:default.notification.failedTrackingDetails')}!`),
      }),
    );
  }
}

function* getShipmentNotesAndDetailsAction({ payload }) {
  try {
    const { data } = yield call(getShipmentNotesAndDetailsEffects, payload);
    yield put(
      getShipmentNotesAndDetailsSuccess({
        data,
      }),
    );
  } catch (e) {
    yield put(
      getShipmentNotesAndDetailsFail({
        message: getErrorMessageFromAPI(e, `${i18n.t('translation:default.notification.failedTrackingDetails')}!`),
      }),
    );
  }
}

function* getShipperConsigneeDetailsAction({ payload }) {
  try {
    const { data } = yield call(getShipperConsigneeDetailsEffects, payload);
    yield put(
      getShipperConsigneeDetailsSuccess({
        data,
      }),
    );
  } catch (e) {
    yield put(
      getShipperConsigneeDetailsFail({
        message: getErrorMessageFromAPI(e, `${i18n.t('translation:default.notification.failedTrackingDetails')}!`),
      }),
    );
  }
}

function* updateShipmentTrackingDetailsAction({ payload }) {
  try {
    const { data } = yield call(updateShipmentTrackingDetailsEffects, payload);
    if (data?.status === 0) {
      yield call(showNotification, {
        message: data.message,
        type: NOTIFICATION_TYPES.ERROR,
      });
      yield put(updateShipmentTrackingDetailsClear());
    } else if (data?.status === 1) {
      yield call(showNotification, {
        message: data.message,
        type: NOTIFICATION_TYPES.SUCCESS,
      });
      yield put(
        updateShipmentTrackingDetailsSuccess({
          data,
        }),
      );

      // TODO: refactor
      yield put(updateSearchVisibilityList({ shipmentKey: data.shipmentkey }));
    } else {
      yield put(
        updateShipmentTrackingDetailsSuccess({
          data: 'Error',
        }),
      );
    }
  } catch (e) {
    yield put(
      updateShipmentTrackingDetailsFail({
        message: getErrorMessageFromAPI(e, `${i18n.t('translation:default.notification.failedTrackingDetails')}!`),
      }),
    );
  }
}

function* getVisibilityExcelDataAction({ payload }) {
  try {
    const { data } = yield call(getVisibilityExportExcelEffects, payload);
    yield put(
      getVisibilityExcelDataSuccess({
        data,
      }),
    );
  } catch (e) {
    yield put(
      getVisibilityExcelDataError({
        message: getErrorMessageFromAPI(e, `${i18n.t('translation:default.fields.failedToGetExcelDataDetails')}!`),
      }),
    );
  }
}

function* sendEMailActions({ payload }) {
  try {
    yield call(sendEmailEffects, payload);

    yield call(showNotification, {
      message: i18n.t('translation:default.fields.documentEmailsSuccessfullySent'),
      type: NOTIFICATION_TYPES.SUCCESS,
    });
  } catch (e) {
    const errMsg = getErrorMessageFromAPI(e, i18n.t('translation:default.fields.failedToSendDocumentEmail'));
    yield call(showNotification, {
      message: errMsg,
      type: NOTIFICATION_TYPES.ERROR,
    });
  }
}

function* updateRefAndDockNoAction({ payload }) {
  const {
    auth: { selectedCompany },
  } = yield select((state) => state);
  try {
    const { data } = yield call(updateRefAndDockNoEffects, payload);
    yield call(showNotification, {
      message: i18n.t('translation:default.fields.updateTheReferenceAndDockNumberSuccess'),
      type: NOTIFICATION_TYPES.SUCCESS,
    });
    yield put(
      updateRefAndDockNoSuccess({
        data,
      }),
    );
    yield put(editGeneralBtn());
    yield put(setShipmentData({}));
    yield put(
      getShipmentDetailsInProgress({
        CustomerKey: selectedCompany?.companyId,
        ShipmentKey: payload.Shipmentkey,
      }),
    );
  } catch (e) {
    const errMsg = i18n.t('translation:default.fields.failedToUpdateTheReferenceAndDockNumber');

    yield call(showNotification, {
      message: errMsg,
      type: NOTIFICATION_TYPES.ERROR,
    });

    yield put(
      updateRefAndDockNoFail({
        message: getErrorMessageFromAPI(e, errMsg),
      }),
    );
    yield put(editGeneralBtn());
  }
}

function* updateShipmentNoteAction({ payload }) {
  const {
    auth: { selectedCompany },
  } = yield select((state) => state);

  try {
    yield put(setAppLoader(true));

    yield call(updateShipmentNoteEffects, payload);
    yield call(showNotification, {
      message: i18n.t('translation:default.fields.updateShipmentNoteSuccess'),
      type: NOTIFICATION_TYPES.SUCCESS,
    });

    yield put(setShipmentData({}));
    yield put(
      getShipmentDetailsInProgress({
        CustomerKey: selectedCompany?.companyId,
        ShipmentKey: payload.shipmentkey,
      }),
    );
    yield put(getShipmentNotesAndDetails({ shipmentNumber: payload.TrackingNumber }));

    yield put(setAppLoader(false));
  } catch {
    const errMsg = i18n.t('translation:default.fields.failedToUpdateShipmentNote');
    yield put(setAppLoader(false));

    yield call(showNotification, {
      message: errMsg,
      type: NOTIFICATION_TYPES.ERROR,
    });
  }
}

function* updateShipmentDetailsAction({ payload }) {
  const {
    auth: { selectedCompany },
  } = yield select((state) => state);

  try {
    yield put(setAppLoader(true));

    yield call(updateShipmentDetailsEffects, payload);
    yield call(showNotification, {
      message: i18n.t('translation:default.fields.updatedShipmentDetailsSuccessfully'),
      type: NOTIFICATION_TYPES.SUCCESS,
    });

    yield put(editDetailsBtn());
    yield put(setShipmentData({}));
    yield put(
      getShipmentDetailsInProgress({
        CustomerKey: selectedCompany?.companyId,
        ShipmentKey: payload.Shipmentkey,
      }),
    );
    yield put(getShipmentNotesAndDetails({ shipmentNumber: payload.trackingNumber }));

    yield put(setShipmentData({}));
    yield put(
      getShipmentDetailsInProgress({
        CustomerKey: selectedCompany?.companyId,
        ShipmentKey: payload.shipmentkey,
      }),
    );
    yield put(setAppLoader(false));
  } catch {
    const errMsg = i18n.t('translation:default.fields.failedToUpdateShipmentDetails');
    yield put(setAppLoader(false));

    yield call(showNotification, {
      message: errMsg,
      type: NOTIFICATION_TYPES.ERROR,
    });

    yield put(editDetailsBtn());
  }
}

function* updateVisibilitySearchListAction({ payload }) {
  // TODO:
  // Added within: 15077
  // This functionality is a temporary workaround that should be reviewed and removed in the future.
  // On the "Shipment Tracking" page, after updating data on the "Tracking Status Details" tab,
  // the changes are not reflected in the <VisibilityMiniCard /> and <GeneralTab /> components.
  // The data for these components is retrieved via a request to /VisibilityAPI/GetSearchResult.
  // As a result, to see the changes, a new request for the entire list has to be made. In this functionality,
  // we silently replacing the data in the store after changes are made. In the future, we might consider
  // a solution where reflecting changes in the selected card doesn't require requesting the entire list.

  // Here functionality copying getVisibilitySearchListAction, but with some additions
  // like replacing only one item that was targeted by this action.

  const { visibilitySearchList } = yield select((state) => state.visibility);
  const {
    user: { data: userDetails },
  } = yield select((state) => state.auth);

  try {
    const targetItemIndexInStore = visibilitySearchList.data?.findIndex(
      (item) => item.shipmentkey === payload.shipmentKey,
    );

    const targetPageIndex =
      visibilitySearchList.data?.length > 0
        ? Math.ceil((targetItemIndexInStore + 1) / visibilitySearchList.req.pageSize)
        : 1;

    const newReqData = {
      ...visibilitySearchList.req,
      pageIndex: targetPageIndex,
      userType: userDetails.userType,
    };

    const { data } = yield call(getVisibilitySearchListEffects, newReqData);

    const targetItemInResponse = data.totalData?.find((item) => item.shipmentkey === payload.shipmentKey);

    if (targetItemInResponse && targetItemIndexInStore) {
      const updatedStoreList = [...visibilitySearchList.data];
      updatedStoreList[targetItemIndexInStore] = targetItemInResponse;
      yield put(updateSearchVisibilityListSuccess({ data: updatedStoreList }));
    }
  } catch (e) {
    yield put(
      getSearchVisibilityListError({
        message: getErrorMessageFromAPI(e, `${i18n.t('translation:default.notification.failedTrackingDetails')}!`),
      }),
    );
  }
}

export default function* visibilitySaga() {
  yield takeLatest(VisibilityTypes.GET_VISIBILITY_SEARCH_LIST, getVisibilitySearchListAction);
  yield takeLatest(VisibilityTypes.UPDATE_VISIBILITY_SEARCH_LIST, updateVisibilitySearchListAction);
  yield takeLatest(VisibilityTypes.GET_TRACKING_STATUS_DETAILS, getTrackingStatusDetailsAction);
  yield takeLatest(VisibilityTypes.GET_VISIBILITY_PRODUCT_INFO, getVisibilityProductInfoAction);
  yield takeLatest(VisibilityTypes.GET_SHIPMENT_NOTES_AND_DETAILS, getShipmentNotesAndDetailsAction);
  yield takeLatest(VisibilityTypes.GET_SHIPPER_AND_CONSIGNEE_DETAILS, getShipperConsigneeDetailsAction);
  yield takeLatest(VisibilityTypes.UPDATE_SHIPMENT_TRACKING_DETAILS, updateShipmentTrackingDetailsAction);
  yield takeLatest(VisibilityTypes.GET_VISIBILITY_EXCEL_DATA, getVisibilityExcelDataAction);
  yield takeLatest(VisibilityTypes.SENT_EMAIL_VISIBILITY, sendEMailActions);

  yield takeLatest(VisibilityTypes.UPDATE_REF_AND_DOCK_NO, updateRefAndDockNoAction);

  yield takeLatest(VisibilityTypes.UPDATE_SHIPMENT_NOTE, updateShipmentNoteAction);

  yield takeLatest(VisibilityTypes.UPDATE_SHIPMENT_DETAILS, updateShipmentDetailsAction);
}
